module.exports = __webpack_public_path__ + "img/Become_A_Friend.png";